if (!customElements.get("vbb-promo-banner")) {
  customElements.define(
    "vbb-promo-banner",
    class PromoBanner extends HTMLElement {
      constructor() {
        super();
        this.startTicker();
      }

      startTicker() {
        const banner = this.querySelector(`#${this.dataset.sectionId}`);
        const firstLine = this.querySelector("li");
        const lineCount = this.querySelectorAll("li").length;

        let tickerTime = 6000;

        if (banner && banner.dataset.tickerTime) {
          tickerTime = parseInt(banner.dataset.tickerTime, 10) * 1000;
        }

        if (firstLine) {
          firstLine.style.marginTop = 0;

          const interval = setInterval(() => {
            const currentMargin = parseInt(
              firstLine.style.marginTop.replace("px", ""),
              10
            );
            const maxMargin = (lineCount - 1) * -30;

            firstLine.style.marginTop =
              currentMargin === maxMargin ? 0 : `${currentMargin - 30}px`;
          }, tickerTime);
        }
      }
    }
  );
}
